"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfferJobAreas = getOfferJobAreas;
const axios_1 = require("./clients/axios");
async function getOfferJobAreas() {
    const response = await axios_1.client.get('/0/job-area');
    return response.data;
}
